import { fetchPersea } from "@/config/axios/config-axios";

export const getCollectible = async (id: string) => {
  const response = await fetchPersea(`/nft?token_id=${id}`, 'GET', { cache: true });
  return Array.isArray(response) ? response[0] : response;
};

export const getCollectibles = async (params = {}) => {
  const defaultParams = {
    cache: "true",
    ...params
  };
  return await fetchPersea(`/nft`, 'GET', { ...defaultParams });
};